var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroDecal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "510px",
    height: "664px",
    className: "img-fluid",
    viewBox: "0 0 510 664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(241, 52, 51)",
    d: "M405.680,663.753 L246.948,663.753 L350.154,547.198 L0.701,105.132 L0.701,0.051 L77.351,0.051 L509.490,546.594 L405.680,663.753 ZM174.522,663.753 L13.979,663.753 L117.185,547.802 L0.701,401.654 L0.701,201.155 L277.125,547.198 L174.522,663.753 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDecal);
export default __webpack_public_path__ + "static/media/hero_decal.2952b287c3b92adfed48d2cd026a99a4.svg";
export { ForwardRef as ReactComponent };